import React from "react";
import MenuTool from "../../components/Toolnav/MenuTool";
import { CiSearch } from "react-icons/ci";

export default function AllMessages() {
  return (
    <div>
      <MenuTool
        menus={[{ id: 1, name: "All Messages", to: "/messages" }]}
        actions={<></>}
      />
      <div className="m-2">
        <div className="p-2 flex flex-col items-center justify-center border bg-white h-48">
          <div className="">
            <CiSearch />
          </div>
          <div className="flex justify-between items-center">No Messages</div>
          <div className="text-gray-500 text-xs">
            No messages, please try again latter
          </div>
        </div>
      </div>
    </div>
  );
}
